import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';

import { map, withLatestFrom, filter } from 'rxjs/operators';
import { Actions } from '../../actions';
import { FinishAssetUpload, GetAssetStatus } from '../action-creators';
import AppState from '../../state';
import { FINISH_ASSET_UPLOAD } from '../actions';
import { AssetUpload } from '../../../types/assets/asset-upload';

export const getStatusAfterVideoEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, FinishAssetUpload>(FINISH_ASSET_UPLOAD),
    withLatestFrom(state$),
    map(([action, state]): [FinishAssetUpload, AssetUpload, AppState] => {
      const asset = state.assets.assets[action.assetId];

      return [action, asset, state];
    }),
    filter(
      ([_action, asset, _state]: [FinishAssetUpload, AssetUpload, AppState]) => {
        return asset && (asset.url ? asset.url.includes(`/video/${asset.id}`) : false);
      }
    ),
    map(([action]) => {
      const category = 'video';

      return new GetAssetStatus(category, [action.assetId]);
    })
  );
